<template>
    <a :href="url" class="search-card search-card__article">
        <div class="search-card__body">
            <div class="search-card__details">
                <a :href="url"  v-if="pageTitle" class="search-card__page-title">{{ pageTitle }}</a>
            </div>
        </div>
    </a>
</template>

<script>
export default {
    props: ["pageTitle", "url"],
    data() {
        return {

        }
    }
}
</script>

